import { render, staticRenderFns } from "./AddClerk.vue?vue&type=template&id=10d00b52&scoped=true&"
import script from "./AddClerk.vue?vue&type=script&lang=js&"
export * from "./AddClerk.vue?vue&type=script&lang=js&"
import style0 from "./AddClerk.vue?vue&type=style&index=0&id=10d00b52&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10d00b52",
  null
  
)

export default component.exports